import React, {Component} from 'react';
import { Grid, CircularProgress } from '@mui/material';


export default class LoadingModal extends Component {
    render() {
        if(this.props.loading){
            return (
                <Grid container justifyContent="center" style={{
                    backgroundColor: 'rgba(0, 0, 0, 0.2)',
                    width: '100vw',
                    height: '100vh',
                    position: 'fixed',
                    zIndex: '999999',
                    top: '0',
                    left: '0'
                }}>
                    <CircularProgress color="secondary" style={{
                        width: '60px',
                        height: '60px',
                        marginTop: 'calc(50vh - 100px)',
                        marginBottom: 'calc(50vh - 100px)'
                        }}/>
                </Grid>
            );
        }
        return (<React.Fragment></React.Fragment>);
    }
}